<template>
  <div class="notify_detail_panel after_border">
    <img :src="logoImg" class="headimg">
    <div class="info">
      <div class="name">{{ title }}</div>
      <div class="message">
        <div class="triangle_border_left"></div>
        <div class="content">
          {{ notify.content }}
        </div>
      </div>
      <div class="time">{{ notify.add_time_format }}</div>
    </div>

  </div>
</template>

<script>
import logoImg from '@/assets/images/logo_small.jpg'

export default {
  name: 'NotifyDetailPanel',
  components: {
  },
  props: {
    // 消息类型 1系统通知
    type: {
      type: Number,
      default: 1
    },
    notify: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      title: '',
      logoImg: logoImg
    }
  },
  created () {
    if (this.type === 1) {
      this.title = '系统消息'
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.notify_detail_panel {
  padding: 25px 20px;
  display: flex;
  .headimg {
    width: 90px;
    height: 90px;
    border-radius: 50%;
  }
  .info {
    margin-left: 20px;
    width: 580px;
    .name, .time {
      font-size: 24px;
      color: #bbb;
    }
    .message {
      margin: 5px 0 10px 0;
      background-color: #f8f8f8;
      font-size: 26px;
      padding: 15px;
      position: relative;
      border-radius: 10px;
    }
  }
}

</style>
